exports.log = function (msg) {
  console.log(msg);
};



//////////////////
// WEBPACK FOOTER
// ./log.js
// module id = 1
// module chunks = 0